export const categories = [
  {
    slug: 'wenwan-bajian',
    name: '文玩把件',
    description: '精选各类文玩把件，包括核桃、菩提、玉石等，每一件都经过匠人精心打磨，手感温润，盘玩之间自得其乐。',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20traditional%20Chinese%20collectible%20hand%20pieces%20including%20walnuts%20and%20bodhi%20seeds%20on%20dark%20wooden%20surface%2C%20warm%20natural%20lighting%2C%20soft%20shadows%2C%20minimalist%20composition%2C%20artisan%20craftsmanship%20aesthetic%2C%20cream%20background%20with%20subtle%20texture&width=800&height=600&seq=cat-wenwan-01&orientation=landscape',
    productCount: 24,
  },
  {
    slug: 'gongyi-baijian',
    name: '工艺摆件',
    description: '汇聚紫砂、陶瓷、木雕等精美工艺品，方寸之间彰显东方美学，为生活空间增添一抹雅致韵味。',
    image: 'https://readdy.ai/api/search-image?query=Exquisite%20Chinese%20ceramic%20and%20wood%20carving%20decorative%20pieces%20displayed%20elegantly%20on%20shelves%2C%20warm%20amber%20lighting%2C%20traditional%20oriental%20aesthetic%2C%20minimalist%20cream%20background%2C%20artisan%20craftsmanship%20with%20refined%20textures&width=800&height=600&seq=cat-gongyi-01&orientation=landscape',
    productCount: 36,
  },
  {
    slug: 'chaye-chaju',
    name: '茶器茶具',
    description: '精选紫砂壶、盖碗、茶杯等茶道器具，从泥土到火焰，从指尖到唇边，每一件茶器都诉说着千年茶文化的温度。',
    image: 'https://readdy.ai/api/search-image?query=Traditional%20Chinese%20tea%20set%20with%20yixing%20purple%20clay%20teapot%20and%20small%20teacups%20on%20wooden%20tea%20tray%2C%20soft%20natural%20light%20from%20window%2C%20elegant%20oriental%20tea%20ceremony%20atmosphere%2C%20cream%20background%2C%20warm%20tones&width=800&height=600&seq=cat-chaju-01&orientation=landscape',
    productCount: 42,
  },
  {
    slug: 'shoucang-jingpin',
    name: '收藏精品',
    description: '涵盖玉器、瓷器、书画等高端收藏品，每一件都是时间沉淀的精华，值得世代传承的掌中瑰宝。',
    image: 'https://readdy.ai/api/search-image?query=Premium%20Chinese%20jade%20carving%20and%20porcelain%20collectibles%20displayed%20in%20glass%20case%20with%20museum%20lighting%2C%20elegant%20warm%20atmosphere%2C%20cream%20background%2C%20refined%20artisan%20craftsmanship%2C%20subtle%20luxury%20aesthetic&width=800&height=600&seq=cat-shoucang-01&orientation=landscape',
    productCount: 18,
  },
  {
    slug: 'liwu-jingxuan',
    name: '礼物精选',
    description: '为重要的人挑选一份有温度的礼物，从商务赠礼到亲友馈赠，每一份掌中之物都承载着真挚的心意与祝福。',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20Chinese%20gift%20boxes%20wrapped%20in%20silk%20ribbon%20with%20traditional%20craft%20items%20inside%2C%20warm%20golden%20lighting%2C%20luxurious%20yet%20minimalist%20presentation%2C%20cream%20background%2C%20thoughtful%20gifting%20aesthetic&width=800&height=600&seq=cat-liwu-01&orientation=landscape',
    productCount: 30,
  },
  {
    slug: 'wenfang-sibao',
    name: '文房雅器',
    description: '笔墨纸砚、镇纸笔搁，传统文房用品承载着千年文人雅趣，在现代书房中延续东方智慧与审美的传承。',
    image: 'https://readdy.ai/api/search-image?query=Traditional%20Chinese%20scholar%20studio%20items%20including%20inkstone%20brush%20and%20paperweight%20on%20wooden%20desk%2C%20soft%20natural%20light%2C%20elegant%20oriental%20scholar%20aesthetic%2C%20cream%20background%2C%20refined%20cultural%20atmosphere&width=800&height=600&seq=cat-wenfang-01&orientation=landscape',
    productCount: 16,
  },
];

export const getCategoryBySlug = (slug: string) => {
  return categories.find((c) => c.slug === slug) || null;
};